import styled from "styled-components";

export const LocationIconStyled = styled.button`
  position: absolute;
  bottom: 20px;
  left: 20px;
  background-color: white;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    bottom: 240px;
    left: 30px;
  }
`;
